import React,{useState} from 'react';   
//import { useSelector } from 'react-redux';

//  interface DataObject {
//     [key: string]: number;
//   }



const  CategoryFiltersLeft = ({searchFilters}) => {
    const [selectedPriceRange, setSelectedPriceRange] = useState('All') 
    const [searchText, setSearchText] = useState('')  

  
     const handlePriceRangeClick = (priceRange) => {
        setSelectedPriceRange(priceRange);
        searchFilters(searchText,priceRange)
    }

    

    const searchQuery = () => {
        searchFilters(searchText,selectedPriceRange)
    }

  
    const resetFilters =() => {
        setSearchText('');
        setSelectedPriceRange('All');
        searchFilters('','All')
    }

  return (
    <div className="col-20 col-xl-3">
        <div className="sticky-xl-top">
            <a href="#!" className="panel-close-btn">																	
                <svg width="35" height="35" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M37.748 12.5L12.748 37.5" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.748 12.5L37.748 37.5" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
            <div className="shop-filter mt-xl-2 mt-0">
                <aside>
                    <div className="d-flex align-items-center justify-content-between m-b30">
                        <h6 className="title mb-0 fw-normal d-flex">
                            <i className="flaticon-filter me-3"></i>
                            Filter
                        </h6>
                        <button className="btn btn-sm font-14 btn-secondary btn-sharp " onClick={() => resetFilters()}>RESET</button>

                    </div>
                    <div className="widget widget_search">
                        <div className="form-group">
                            <div className="input-group">
                                <input name="dzSearch"  type="search" className="form-control" onChange={(e) => setSearchText(e.target.value)} value={searchText} placeholder="Search Product"/>
                                <div className="input-group-addon">
                                    <button  className="btn" onClick={() => searchQuery()}>
                                        <i className="icon feather icon-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="widget widget_categories">
                        <h6 className="widget-title">Price Range</h6>
                        <ul>
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === 'All' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('All')} >All</button> </li> 
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === 'below_500' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('below_500')} >below ₹500</button> </li> 
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === '500_to_1000' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('500_to_1000')} > ₹500 to ₹1,000</button> </li> 
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === '1000_to_2000' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('1000_to_2000')} > ₹1,000 to ₹2,000</button> </li> 
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === '2000_to_5000' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('2000_to_5000')} > ₹2,000 to ₹5,000</button> </li> 
                             <li className={"cat-item cat-item-26 " + (selectedPriceRange === 'above_5000' ? 'active' : '')} ><button className='removeBtnBG' onClick={() => handlePriceRangeClick('above_5000')} > above ₹5,000</button> </li> 
                
                        </ul>
                    </div>
                    
                 
                    
                    <div className="widget widget_tag_cloud">
                        <h6 className="widget-title">Tags</h6>
                        <div className="tagcloud"> 
                            <a href="#!">Wedding</a>
                            <a href="#!">Cotton</a>
                            <a href="#!">Linen</a>
                            <a href="#!">Pichuwai</a>
                            <a href="#!">Kalmkari</a>
                            <a href="#!">Paithani</a>
                            <a href="#!">Digital Printing</a>
                        </div>
                    </div>
                    <button className="btn btn-sm font-14 btn-secondary btn-sharp " onClick={() => resetFilters()}>RESET</button>
                </aside>
            </div>
        </div>
    </div>
  );
}

export default CategoryFiltersLeft;

 
